import { Training } from '../services/trainings.service';

/**
 * Formats the location display for a training
 * Handles Algeria wilaya display and other countries city display
 * This is separate from the address field which is a string
 * Priority: Uses training's location first, then falls back to training center location
 */
export const formatTrainingLocation = (training: Training, t?: any): string => {
  // Priority 1: Training's own location
  const country = training.country?.name || training.training_center?.country?.name;
  const city = training.city || training.training_center?.city;
  const wilaya = training.wilaya?.name || training.training_center?.wilaya?.name;

  if (!country) {
    return t ? t('common.locationNotSpecified', 'Lieu non spécifié') : 'Lieu non spécifié';
  }

  // If country is Algeria, prioritize wilaya over city
  if (country.toLowerCase() === 'algeria' || country.toLowerCase() === 'algérie') {
    if (wilaya) {
      return `${wilaya}, ${country}`;
    } else if (city) {
      return `${city}, ${country}`;
    } else {
      return country;
    }
  } else {
    // For other countries, show city, country
    if (city) {
      return `${city}, ${country}`;
    } else {
      return country;
    }
  }
};

/**
 * Formats the location display specifically for a training center
 * Uses ONLY the training center's location, not the training's location
 */
export const formatTrainingCenterLocation = (trainingCenter: any, t?: any): string => {
  const country = trainingCenter?.country?.name;
  const city = trainingCenter?.city;
  const wilaya = trainingCenter?.wilaya?.name;

  if (!country) {
    return t ? t('common.locationNotSpecified', 'Lieu non spécifié') : 'Lieu non spécifié';
  }

  // If country is Algeria, prioritize wilaya over city
  if (country.toLowerCase() === 'algeria' || country.toLowerCase() === 'algérie') {
    if (wilaya) {
      return `${wilaya}, ${country}`;
    } else if (city) {
      return `${city}, ${country}`;
    } else {
      return country;
    }
  } else {
    // For other countries, show city, country
    if (city) {
      return `${city}, ${country}`;
    } else {
      return country;
    }
  }
};


/**
 * Gets the city/wilaya name for display
 */
export const getCityDisplay = (training: Training, t?: any): string => {
  const country = training.country?.name || training.training_center?.country?.name;
  const city = training.city || training.training_center?.city;
  const wilaya = training.wilaya?.name || training.training_center?.wilaya?.name;

  // If country is Algeria, prioritize wilaya over city
  if (country?.toLowerCase() === 'algeria' || country?.toLowerCase() === 'algérie') {
    return wilaya || city || (t ? t('common.notSpecified', 'Non spécifié') : 'Non spécifié');
  } else {
    return city || (t ? t('common.notSpecified', 'Non spécifié') : 'Non spécifié');
  }
};

// Keep the old function names for backward compatibility but redirect to location functions
export const formatTrainingAddress = formatTrainingLocation;
export const formatAddress = formatTrainingLocation;
